<template>
  <button class="chip" :class="{ active: isActive }">
    <Text variant="label-medium" :color="textColor">
      <slot />
    </Text>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Text from '../text.vue';

const props = withDefaults(defineProps<{ isActive?: boolean }>(), {
  isActive: false,
});

const textColor = computed(() => (props.isActive ? 'primary' : 'secondary'));
</script>

<style scoped lang="scss">
.chip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--t-spacing-md);

  font-size: 0.875rem;
  font-weight: 500;

  line-height: 1.25rem;
  padding: 0.5rem;
  width: fit-content;
  height: 2rem;
  white-space: nowrap;
  border: none;
  background: transparent;
  appearance: none;
  border: 1px solid transparent;
  border-radius: var(--t-border-radius-sm);

  &:hover,
  &:focus {
    cursor: pointer;
    background: var(--t-color-grey-100);
    border-color: var(--t-color-grey-100);
  }

  &:focus {
    border-color: var(--t-color-neutral-950);
    outline: none;
  }

  &.active {
    background: var(--t-color-grey-100);
    border-color: var(--t-color-grey-100);
  }
}
</style>
